import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject, defer, Observable } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class EventspageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  eventsData: any;
  eventsDetailData: any;

  private eventsHeroSubject$ = new BehaviorSubject<any>(null);
  public eventsHero$ = this.eventsHeroSubject$.asObservable();
  private eventsUpcomingEventsContentPanelSubject$ = new BehaviorSubject<any>(
    null
  );
  public eventsUpcomingEventsContentPanel$ =
    this.eventsUpcomingEventsContentPanelSubject$.asObservable();
  private eventsBlogArticlesContentPanelSubject$ = new BehaviorSubject<any>(
    null
  );
  public eventsBlogArticlesContentPanel$ =
    this.eventsBlogArticlesContentPanelSubject$.asObservable();
  private eventsFaqContentPanelSubject$ = new BehaviorSubject<any>(null);
  public eventsFaqContentPanel$ =
    this.eventsFaqContentPanelSubject$.asObservable();
  private eventsPastEventsContentPanelSubject$ = new BehaviorSubject<any>(null);
  public eventsPastEventsContentPanel$ =
    this.eventsPastEventsContentPanelSubject$.asObservable();

  private eventsDetailDataSubject$ = new BehaviorSubject<any>(null);
  public eventsDetailData$ = this.eventsDetailDataSubject$.asObservable();

  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  today = new Date();

  geteventsPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.eventsPage,
          include: 10,
        })
      )
      .then(res => {
        this.eventsData = res.items as Entry<any>[];
        const heroData =
          this.eventsData[0].fields.heroHeaderContentPanel.fields;
        if (heroData) {
          this.eventsHeroSubject$.next(heroData);
        }
        const upcomingEventsContentPanelData =
          this.eventsData[0].fields.upcomingEventsContentPanel.fields;
        if (upcomingEventsContentPanelData) {
          this.eventsUpcomingEventsContentPanelSubject$.next(
            upcomingEventsContentPanelData
          );
        }
        const blogData =
          this.eventsData[0].fields.blogArticlesContentPanel.fields;
        if (blogData) {
          this.eventsBlogArticlesContentPanelSubject$.next(blogData);
        }
        const faqData = this.eventsData[0].fields.faqContentPanel.fields;
        if (faqData) {
          this.eventsFaqContentPanelSubject$.next(faqData);
        }
        const pastEventsData =
          this.eventsData[0].fields.pastEventsContentPanel.fields;
        if (pastEventsData) {
          this.eventsPastEventsContentPanelSubject$.next(pastEventsData);
        }
        const getStarted = this.eventsData[0].fields.gettingStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }

  getPastEvents(): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.eventArticlePages,
          // 'fields.dateTime[lt]': this.today,
        })
      )
      .then(res => res.items);
  }

  getevEntsListBySearch(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.eventArticlePages,
          // 'fields.dateTime[lt]': this.today,
          query: query,
        })
      )
      .then(res => res.items);
  }

  getevEntsListByRegion(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.eventArticlePages,
          // 'fields.dateTime[lt]': this.today,
          'fields.selectRegion': query,
        })
      )
      .then(res => res.items);
  }

  getevEntsListByIndustry(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.eventArticlePages,
          // 'fields.dateTime[lt]': this.today,
          'fields.selectIndustry': query,
        })
      )
      .then(res => res.items);
  }

  getevEntsListByRegionIndustry(
    query1: string,
    query2: string
  ): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.eventArticlePages,
          // 'fields.dateTime[lt]': this.today,
          'fields.selectRegion': query1,
          'fields.selectIndustry': query2,
        })
      )
      .then(res => res.items);
  }

  getAllEventsDetail(): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.eventArticlePages,
        })
      )
      .then(res => {
        const mod = res.items as any[];
        return mod;
      });
  }
  getEventsDetailByID(query: any): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.eventArticlePages,
          'fields.webPageId': query,
        })
      )
      .then(res => res.items);
  }

  getEventsDetailData(id: string) {
    this.getEventsDetailByID(id).then(data => {
      this.eventsDetailData = data[0]?.fields;
      if (this.eventsDetailData) {
        this.eventsDetailDataSubject$.next(this.eventsDetailData);
      }
    });
  }
}
